import { localSetJson, localGetJson } from 'Shared/local_storage_lib';

type RecentlySeenEntry = {
   lastSeen: number;
   count: number;
};

type RecentlySeenMap = {
   [id: string]: RecentlySeenEntry;
};

const localStorageKey = 'recently-seen-banners';

export const getRecentlySeenMap = (): RecentlySeenMap => {
   return localGetJson(localStorageKey) || {};
};

const setRecentlySeenMap = (recentlySeenMap: RecentlySeenMap): boolean => {
   return localSetJson(localStorageKey, recentlySeenMap);
};

export const updateEntry = (id: string): void => {
   const recentlySeenMap = getRecentlySeenMap();
   const entry = recentlySeenMap[id];
   if (entry) {
      entry.lastSeen = Date.now();
      entry.count += 1;
   } else {
      recentlySeenMap[id] = {
         lastSeen: Date.now(),
         count: 1,
      };
   }
   setRecentlySeenMap(recentlySeenMap);
};

export const resetEntry = (id: string): void => {
   const recentlySeenMap = getRecentlySeenMap();
   const entry = recentlySeenMap[id];
   if (entry) {
      entry.lastSeen = 0;
      entry.count = 0;
   }
   setRecentlySeenMap(recentlySeenMap);
};
